(() => {
  let isLoading = false;

  function getElements() {
    return {
      grid: document.querySelector('#product-grid'),
      pagination: document.querySelector('#InfiniteScrollPagination'),
      loader: document.querySelector('#InfiniteScrollLoader')
    };
  }

  async function loadMoreProducts() {
    const { grid, pagination, loader } = getElements();

    if (!grid || !pagination || isLoading) return;

    const nextUrl = pagination.dataset.nextUrl;

    if (!nextUrl) return;

    isLoading = true;
    const loadingStartedAt = Date.now();

    if (loader) {
      loader.style.display = 'flex';
    }

    try {
      const response = await fetch(nextUrl);

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const nextGrid = doc.querySelector('#product-grid');
      const nextPagination = doc.querySelector('#InfiniteScrollPagination');

      if (!nextGrid) {
        throw new Error('Next product grid not found');
      }

      const currentProductUrls = new Set(
        Array.from(
          grid.querySelectorAll('a[href*="/products/"]')
        ).map(link => {
          return link.pathname || link.getAttribute('href');
        })
      );

      const newItems = Array.from(
        nextGrid.querySelectorAll(':scope > .grid__item')
      );

      let addedProducts = 0;

      newItems.forEach(item => {
        const productLink = item.querySelector('a[href*="/products/"]');

        if (!productLink) {
          grid.appendChild(item);
          addedProducts++;
          return;
        }

        const productUrl =
          productLink.pathname ||
          productLink.getAttribute('href');

        if (currentProductUrls.has(productUrl)) {
          return;
        }

        grid.appendChild(item);
        currentProductUrls.add(productUrl);
        addedProducts++;
      });

      console.log(
        `Infinite scroll: ${addedProducts} products added`
      );

      if (
        nextPagination &&
        nextPagination.dataset.nextUrl
      ) {
        pagination.dataset.nextUrl =
          nextPagination.dataset.nextUrl;
      } else {
        pagination.remove();
      }

    } catch (error) {
      console.error('Infinite scroll error:', error);
    } finally {
    //   isLoading = false;

    //   const currentLoader =
    //     document.querySelector('#InfiniteScrollLoader');

    //   if (currentLoader) {
    //     currentLoader.style.display = 'none';
    //   }

    //   /*
    //    * Important:
    //    * if the newly loaded products are still not enough
    //    * to create scrolling, check again.
    //    */
    //   setTimeout(checkInfiniteScroll, 100);
     const elapsed = Date.now() - loadingStartedAt;
  const minimumLoaderTime = 600;

  if (elapsed < minimumLoaderTime) {
    await new Promise(resolve =>
      setTimeout(resolve, minimumLoaderTime - elapsed)
    );
  }

  isLoading = false;

  const currentLoader =
    document.querySelector('#InfiniteScrollLoader');

  if (currentLoader) {
    currentLoader.style.display = 'none';
  }

  setTimeout(checkInfiniteScroll, 100);
    }
  }

  function checkInfiniteScroll() {
    const { grid, pagination } = getElements();

    if (!grid || !pagination || isLoading) return;

    const rect = pagination.getBoundingClientRect();

    const loadDistance = 400;

    if (
      rect.top <=
      window.innerHeight + loadDistance
    ) {
      loadMoreProducts();
    }
  }

  /*
   * Normal vertical scrolling
   */
  window.addEventListener(
    'scroll',
    checkInfiniteScroll,
    { passive: true }
  );

  /*
   * Initial check after page load
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      checkInfiniteScroll
    );
  } else {
    checkInfiniteScroll();
  }

  /*
   * Dawn replaces ProductGridContainer when
   * filters or sorting are changed.
   *
   * Observe those replacements and start
   * infinite scroll again automatically.
   */
  const observer = new MutationObserver(() => {
    if (
      document.querySelector('#product-grid') &&
      document.querySelector('#InfiniteScrollPagination')
    ) {
      checkInfiniteScroll();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();